<template lang="pug">
div
	h1 {{contentpage.name}}
	ws-content(:value="contentpage.content")
		accommodation-map.mb-6(v-if="filterstring && showMap" :filterstring="filterstring" :sort="sort" )
		v-row.hidden-xs-only(no-gutters)
			glue-list.font-weight-bold(glue=" - " lastglue=" - ")
				span(v-if="filters.date") {{$dayjs(filters.date).format('D MMMM YYYY')}}
				span(v-if="filters.duration") {{$tc('accommodations-filters.nights', filters.duration)}}
				span(v-if="filters.persons") {{$tc('accommodations-filters.persons', filters.persons)}}
			v-spacer
			areas-sort(v-model="sort")
				li(field="PRICE" ascending) {{$t('accommodations_list.sorting.price')}}
				li(field="RATING") {{$t('accommodations_list.sorting.rating')}}
				li(field="DISTANCE_SKILIFT" ascending) {{$t('accommodations_list.sorting.distance_skilift')}}
		v-divider.mb-3
		v-alert(v-if="showBusMessage" type="info" color="warning" dense) {{$t('accommodations_list.bus_warning')}}
		accommodation-list(v-if="filterstring" :filterstring="filterstring" :sort="sort" )
</template>

<script>
import gql from 'graphql-tag';
import Content from '@dengl/common/components/content.vue';
import AccommodationList from '@dengl/common/components/accommodations/list.vue';
import AccommodationMap from '@dengl/common/components/accommodations/map.vue';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import AreasSort from '@/components/areas/sort';

const { decodeFilters } = require('@dengl/common/utils/filterstrings');

const query = gql`
	query getAccommodationPage($path: String) {
		contentpage(path: $path) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	name: 'AccommodationsIndex',
	nuxtI18n: {
		paths: {
			'nl-NL': '/accommodatie/resultaten',
			'nl-BE': '/accommodatie/resultaten'
		}
	},
	components: {
		AreasSort,
		AccommodationList,
		AccommodationMap
	},
	asyncData({ app, route }) {
		return app.$graphClient
			.query({
				query,
				variables: {
					path: route.path
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return app.httpError(404, null, 'accommodations-01', errors);
				}
				if (errors) {
					throw errors[0];
				}
				data.filterstring = app.filterstring;
				app.meta(data.contentpage.meta);
				app.ads({
					accosearchresults: { visible: true, type: 'accommodation' }
				});
				app.breadcrumbs({
					[data.contentpage.name]: {
						name: 'accommodations-search'
					}
				});

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'accommodations-02', error);
			});
	},
	data() {
		return {
			sort: {
				ascending: true,
				field: 'PRICE'
			}
		};
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		filters() {
			return decodeFilters(this.filterstring, this.$i18n.locale);
		},
		showBusMessage() {
			return this.filters.transporttype === 'bus';
		},
		showMap() {
			return this.filters.showMap;
		}
	},
	watch: {
		'$route.hash'(val) {
			this.filterstring = val.replace('#', '');
		}
	},
	mounted() {
		if (this.$route.hash && !this.filterstring) {
			this.filterstring = this.$route.hash.replace('#', '');
		}
		if (!this.$route.hash && this.$store.state.accohash) {
			this.$router
				.replace(
					this.localePath({
						name: 'accommodations-search',
						hash: this.$store.state.accohash
					})
				)
				.catch(_e => {});
		}
	}
};
</script>
